import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Row, Col, Statistic } from 'antd';
import { ReadOutlined, ShoppingOutlined, UserOutlined, TeamOutlined, SmileOutlined, TrophyOutlined } from '@ant-design/icons';
import { companyAPI } from '../services/api';
import { PAID_CONTENT_LABEL } from '../constants/labels';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    loadCompanyInfo();
  }, []);

  const loadCompanyInfo = async () => {
    try {
      const res = await companyAPI.getInfo();
      setCompanyInfo(res.data);
    } catch (error) {
      console.error('加载公司信息失败');
    }
  };

  if (!companyInfo) {
    return <div className="loading-container">加载中...</div>;
  }

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">专业AI情绪管理平台</h1>
          <p className="hero-subtitle">
            {companyInfo.description}
          </p>
          <div className="hero-actions">
            <Button
              type="primary"
              size="large"
              icon={<ReadOutlined />}
              onClick={() => navigate('/classroom')}
            >
              {PAID_CONTENT_LABEL}
            </Button>
            <Button
              size="large"
              icon={<ShoppingOutlined />}
              onClick={() => navigate('/mall')}
            >
              情绪商城
            </Button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <Row gutter={[32, 32]}>
            <Col xs={12} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic
                  title="服务用户"
                  value={companyInfo.stats.users}
                  prefix={<UserOutlined />}
                  valueStyle={{ color: '#6366f1' }}
                />
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic
                  title="合作企业"
                  value={companyInfo.stats.enterprises}
                  prefix={<TeamOutlined />}
                  valueStyle={{ color: '#10b981' }}
                />
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic
                  title="专业咨询师"
                  value={companyInfo.stats.consultants}
                  prefix={<SmileOutlined />}
                  valueStyle={{ color: '#f59e0b' }}
                />
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic
                  title="用户满意度"
                  value={companyInfo.stats.satisfaction}
                  prefix={<TrophyOutlined />}
                  valueStyle={{ color: '#ef4444' }}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">我们的服务</h2>

          <Row gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <Card className="service-card" title="个人服务" bordered={false}>
                <ul className="service-list">
                  {companyInfo.services.personal.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card className="service-card" title="企业服务" bordered={false}>
                <ul className="service-list">
                  {companyInfo.services.enterprise.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>开始您的情绪管理之旅</h2>
            <p>专业的心理健康支持，助您找到内心的平衡</p>
            <div className="cta-actions">
              <Button
                type="primary"
                size="large"
                onClick={() => navigate('/register')}
              >
                立即注册
              </Button>
              <Button
                size="large"
                onClick={() => navigate('/about')}
              >
                了解更多
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
